module.exports = __webpack_public_path__ + "static/lucrare-doamne-img-6a49494410ca5eda23daba207efc228d.jpg";